module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAfAQMAAAD6Lv5lAAAAA1BMVEWChYjgXJUoAAAAC0lEQVR4XmOgCAAAAD4AASqr14kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/split.png
// module id = xtag
// module chunks = 1